import React from 'react';
import PropTypes from 'prop-types';

const MonteCarloChartTooltipView = ({
  MonteCarloTrialsCount,
  pos,
  posColor,
  inversePos,
  inversePosColor,
}) => (
  <div className="MonteCarloChartTooltip">
    <h2>Probability of Success</h2>
    We ran {MonteCarloTrialsCount} trials to simulate a range of possible outcomes.
    <ul className="outcomes">
      <li>
        <i style={{ backgroundColor: posColor }} />
        <b>{pos}%</b> of the time you were fully funded for your retirement.
      </li>
      <li>
        <i style={{ backgroundColor: inversePosColor }} />
        <b>{inversePos}%</b> of the time you ran out of money.
      </li>
    </ul>
  </div>
);

MonteCarloChartTooltipView.propTypes = {
  MonteCarloTrialsCount: PropTypes.number.isRequired,
  pos: PropTypes.number.isRequired,
  inversePos: PropTypes.number.isRequired,
  posColor: PropTypes.string.isRequired,
  inversePosColor: PropTypes.string.isRequired,
};

export default MonteCarloChartTooltipView;
